import { render, staticRenderFns } from "./CardBadges.vue?vue&type=template&id=28aa0f17&scoped=true&"
import script from "./CardBadges.vue?vue&type=script&lang=js&"
export * from "./CardBadges.vue?vue&type=script&lang=js&"
import style0 from "./CardBadges.vue?vue&type=style&index=0&id=28aa0f17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa0f17",
  null
  
)

export default component.exports